export const notifications = {
    of: 'of',
    more: 'More',
};
